<div *ngIf="formName.controls[fieldName].invalid && (formName.controls[fieldName].dirty || formName.controls[fieldName].touched)"
    class="alert">
    <div *ngIf="formName.controls[fieldName].errors.required">
        * {{fieldName}} es requerido o no es valido
    </div>
</div>